import { deleteUser } from "../../api/UserDelete";
import { toast } from "react-toastify";
import ErrorUtils from "../../utils/ApiUtils/ErrorUtils";
import { useMutation, useQueryClient } from "react-query";
import UserCacheName from "../../utils/UserCacheName";

export function useDeleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteUser,
    onSuccess: () => {
      toast.success("User deleted successfully!");
      queryClient.invalidateQueries(UserCacheName.getUserList());
    },
    onError: (error: unknown) => {
      console.error("Error deleting user:", error);
      toast.error("Failed to delete user. " + ErrorUtils.getErrorMessage(error));
    },
  });
}
